import React from "react";
import { List, ListItem, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/InfoOutlined";

interface IProps {
  allowed_features: string[];
}

const AllowedFeaturesToolTip: React.FC<IProps> = ({ allowed_features }) => (
  <Tooltip
    title={
      <List>
        {allowed_features.map((feature) => (
          <ListItem style={{ height: 10 }} key={feature}>
            {feature}
          </ListItem>
        ))}
      </List>
    }
  >
    <InfoIcon />
  </Tooltip>
);

export default AllowedFeaturesToolTip;
